import script from "./WCBannerStickyAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCBannerStickyAlert.vue?vue&type=script&setup=true&lang=ts"

import "./WCBannerStickyAlert.vue?vue&type=style&index=0&id=73ea10ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ea10ab"]])

export default __exports__